import {Attribute} from '../asd-attribute';

export class MenuItem{
  DisplayName : string;
  Attributes : Attribute;
  Selected : boolean;

  /*Properties for Groups in CosyJS(Not a part of ASD from Server)*/
  MenuGroup : MenuGroup;
}

export class MenuGroup{
  Head : boolean;
  Member: boolean;
  Closure: boolean;
  DetailView: boolean = false;
  MemberOfHead: any;
  Members: any [] = [];
  Parents: any [] = [];
  CSSClass : string;
}
